const DEFAULT_ADMIN_FILTERS = {
  title: '',
  owner_email: '',
  participant_email: '',
  report_code: '',
  organization_name: ''
};

export default {
  namespaced: true,
  state: {
    landingTab: 'my_reports', // 'my_reports', 'favorites', 'my_data'
    projectSearchParams: {},
    projectSearchTrigger: 0,
    // 관리자 보고서 검색 상태 유지 (#544)
    adminReportFilters: { ...DEFAULT_ADMIN_FILTERS },
    adminFilterSkipKey: null,
    adminHasSearched: false,
    // legacy (keep for backward compatibility)
    projectSearchQuery: '',
    projectSearchCategory: 'project_name',
    projectSearchQuery2: '',
    projectSearchCategory2: 'project_name'
  },
  mutations: {
    SET_LANDING_TAB(state, value) {
      state.landingTab = value;
    },
    SET_PROJECT_SEARCH_PARAMS(state, value) {
      state.projectSearchParams = value;
    },
    SET_PROJECT_SEARCH_QUERY(state, value) {
      state.projectSearchQuery = value;
    },
    SET_PROJECT_SEARCH_CATEGORY(state, value) {
      state.projectSearchCategory = value;
    },
    SET_PROJECT_SEARCH_QUERY2(state, value) {
      state.projectSearchQuery2 = value;
    },
    SET_PROJECT_SEARCH_CATEGORY2(state, value) {
      state.projectSearchCategory2 = value;
    },
    TRIGGER_PROJECT_SEARCH(state) {
      state.projectSearchTrigger++;
    },
    SET_ADMIN_REPORT_FILTERS(state, value) {
      state.adminReportFilters = value;
    },
    SET_ADMIN_FILTER_SKIP_KEY(state, value) {
      state.adminFilterSkipKey = value;
    },
    SET_ADMIN_HAS_SEARCHED(state, value) {
      state.adminHasSearched = value;
    },
    RESET_ADMIN_REPORT_FILTERS(state) {
      state.adminReportFilters = { ...DEFAULT_ADMIN_FILTERS };
      state.adminFilterSkipKey = null;
      state.adminHasSearched = false;
    }
  },
  actions: {
    setLandingTab({ commit }, value) {
      commit('SET_LANDING_TAB', value);
    },
    setProjectSearchParams({ commit }, value) {
      commit('SET_PROJECT_SEARCH_PARAMS', value);
    },
    setProjectSearchQuery({ commit }, value) {
      commit('SET_PROJECT_SEARCH_QUERY', value);
    },
    setProjectSearchCategory({ commit }, value) {
      commit('SET_PROJECT_SEARCH_CATEGORY', value);
    },
    setProjectSearchQuery2({ commit }, value) {
      commit('SET_PROJECT_SEARCH_QUERY2', value);
    },
    setProjectSearchCategory2({ commit }, value) {
      commit('SET_PROJECT_SEARCH_CATEGORY2', value);
    },
    triggerProjectSearch({ commit }) {
      commit('TRIGGER_PROJECT_SEARCH');
    },
    resetAdminReportFilters({ commit }) {
      commit('RESET_ADMIN_REPORT_FILTERS');
    }
  }
};
